import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import { type FC } from "react";

import type { INewsMarker } from "~/feature/chart/types";

import { NewsMarkerTooltip } from "./NewsMarkerTooltip";
import * as Styled from "./NewsMarkerTooltipSlider.styles";
import { useNewsMarkerTooltipSlider } from "./useNewsMarkerTooltipSlider";

interface INewsMarkerTooltipSliderProps {
  markers: INewsMarker[];
}

export const NewsMarkerTooltipSlider: FC<INewsMarkerTooltipSliderProps> = ({
  markers,
}) => {
  const { emblaRef, activeIndex, scrollPrev, scrollNext } =
    useNewsMarkerTooltipSlider();

  return (
    <Styled.Root>
      <Styled.Viewport ref={emblaRef}>
        <Styled.Container>
          {markers.map((marker) => (
            <Styled.Slide key={marker.id}>
              <NewsMarkerTooltip marker={marker} />
            </Styled.Slide>
          ))}
        </Styled.Container>
      </Styled.Viewport>

      <Styled.Nav>
        <Styled.NavButton
          aria-label="Previous news"
          disabled={activeIndex === 0}
          onClick={scrollPrev}
        >
          <ChevronLeftIcon />
        </Styled.NavButton>

        <Styled.Counter>{`${activeIndex + 1} / ${markers.length}`}</Styled.Counter>

        <Styled.NavButton
          aria-label="Next news"
          disabled={activeIndex === markers.length - 1}
          onClick={scrollNext}
        >
          <ChevronRightIcon />
        </Styled.NavButton>
      </Styled.Nav>
    </Styled.Root>
  );
};
